import * as React from 'react';
import styled from 'styled-components';

import * as colors from '../../shared/colors';
import RenderMark from '../../shared/components/RenderMark';
import t from '../../shared/translations';
import { Tab, TabRow } from '../tasksSidebar/stylings';
import { IData } from './Landing';
import PathGroupMember from './PathGroupMember';

interface IProps {
    path: IData['learningPath'] | null;
}

const Box = styled.div`
    border: 1px solid ${colors.unlight};
    padding: 5px;
    margin-bottom: 1rem;
`;

const Section = styled.section`
    margin-top: 1rem;
`;

type TabType = 'path' | 'programme' | 'my-group';

function Info({ path }: IProps): JSX.Element {
    const [selectedTab, switchTab] = React.useState<TabType>(
        path.programme
            ? 'programme'
            : path.info
                ? 'path'
                : 'my-group',
    );
    return <Section>
        <TabRow>
            {!!path.programme && <>
                <Tab $active={selectedTab === 'programme'} onClick={() => switchTab('programme')}>
                    {t('player.landing.tab-programme-info')}
                </Tab>
            </>}
            {!!path.info && <>
                <Tab $active={selectedTab === 'path'} onClick={() => switchTab('path')}>
                    {t('player.landing.tab-path-info')}
                </Tab>
            </>}
            {!!path.pathGroup && <>
                <Tab $active={selectedTab === 'my-group'} onClick={() => switchTab('my-group')}>
                    {t('player.landing.tab-my-group')}
                </Tab>
            </>}
        </TabRow>
        {path.programme && selectedTab === 'programme' && <Box>
            <h3>{path.programme.name}</h3>
            <RenderMark content={path.programme.info} />
            <h4>{t('player.landing.paths-programme-heading')}</h4>
            <ul>
                {path.programme.paths.map(path => <li key={path.id}>{path.pathname}</li>)}
            </ul>
        </Box>}
        {path.info && selectedTab === 'path' && <Box>
            <h3>{path.pathname}</h3>
            <RenderMark content={path.info} />
        </Box>}
        {path.pathGroup && selectedTab === 'my-group' && <Box>
            {path.pathGroup.members.map(m => <PathGroupMember key={m.id} member={m} />)}
        </Box>}
    </Section>;
}

export default Info;
